import {createSlice} from "@reduxjs/toolkit";
import {ResponseApi} from '../BaseApi';
import { GetAllGeofenceList, GetEvidencesList, GetFinesTrafficDetails,
    GetUserTrafficDetails, CreatePaymentEvidence, GetPaymentEvidence } from "./TrafficApi";

/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const TrafficSlice = createSlice({
    name: "traffic",
    initialState: {
        userTrafficDetails: null,
        finesTrafficDetails: null,
        evidencesList:null,
        getAllGeofenceList:null,
        createPayment: null,
        createPaymentEvidence: null,
        getPaymentEvidence: []
    },
    reducers: {
        modifiedCreateEvidencePayment: (state, action) => {
            state.addEdit = null;
        }
    },
    extraReducers: (builder) => {
        builder.addCase( GetUserTrafficDetails.fulfilled, (state, {payload}) =>{
            state.userTrafficDetails = ResponseApi(payload);
        }).addCase(GetFinesTrafficDetails.fulfilled, (state, {payload}) =>{
            state.finesTrafficDetails = ResponseApi(payload);
        }).addCase(GetEvidencesList.fulfilled, (state, {payload}) =>{
            state.evidencesList = ResponseApi(payload);
        }).addCase(GetAllGeofenceList.fulfilled, (state, {payload}) =>{
            state.getAllGeofenceList = ResponseApi(payload);
        }).addCase(CreatePaymentEvidence.fulfilled, (state, {payload}) =>{
            state.createPaymentEvidence = ResponseApi(payload);
        }).addCase(GetPaymentEvidence.fulfilled, (state, {payload}) =>{
            state.getPaymentEvidence = ResponseApi(payload);
        })
    }

})

export const {  } = TrafficSlice.actions;

export default TrafficSlice.reducer;
